import DisconnectedSteps from '../../../website-mobile/components/DisconnectedSteps/DisconnectedSteps';
import styles from './page2.module.css';

export default function Page2() {
    return (
        <div className={styles.page2} style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='31' y='31' width='2' height='2' fill='%2362A135'/%3E%3C/svg%3E")`, backgroundRepeat: 'repeat', backgroundSize: '64px 64px' }}>
            <DisconnectedSteps />
        </div>
    );
}